// extracted by mini-css-extract-plugin
export default {"section":"Section-module__section--oFny6","withBorder":"Section-module__withBorder--FaeYM","intro":"Section-module__intro--_wpeU"};